<template>
  <Multiselect
    v-model="model"
    :options="options"
    label="value"
    :multiple="true"
    :close-on-select="false"
    :allow-empty="true"
    track-by="key"
    selected-label="✓"
    deselect-label="✓"
    select-label=""
    :placeholder="$t('label.channel')"
    @input="input"
  >
    <template slot="selection" slot-scope="{ values, isOpen }">
      <span v-if="values.length && !isOpen" class="multiselect__single">
        {{ label }}
      </span>
    </template>
    <template slot="clear">
      <span
        v-if="model.length"
        class="multiselect__clear"
        @mousedown.prevent.stop="clearAll()"
      />
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import { pluck, isNil, join, filter } from "ramda";

export default {
  name: "SelectOrderChannel",
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
  },
  data: () => ({
    model: null,
  }),
  computed: {
    options() {
      return [
        { key: "adwords", value: "Adwords" },
        { key: "chatfood", value: "ChatFood" },
        { key: "facebook", value: "Facebook" },
        { key: "google", value: "Google" },
        { key: "instagram", value: "Instagram" },
        { key: "InstagramStories", value: "Instagram Stories" },
        { key: "messenger", value: "Messenger" },
        { key: "web", value: "Web" },
        { key: "whatsapp", value: "WhatsApp" },
      ];
    },
    label() {
      if (isNil(this.model)) return null;
      return join(", ", pluck("value", this.model));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (isNil(val)) {
          this.model = null;
          return;
        }

        this.model = filter((obj) => val.includes(obj.key), this.options);
      },
    },
  },
  methods: {
    input(value) {
      this.$emit("input", pluck("key", value));
    },
    clearAll() {
      this.model = [];
      this.$emit("input", []);
    },
  },
};
</script>
